<div class="modal-header"><h2 class="modal-title">Bank Amount</h2></div>
<div class="modal-body">
  @if (true) {
    <div>
      <dx-form [formData]="batch" validationGroup="statusChangeData" [colCount]="1">
        <dxi-item dataField="deposited" editorType="dxDateBox" [editorOptions]="{width: '150px'}"  ></dxi-item>
        <dxi-item dataField="bankCashAmount" [label]="{ text: 'Cash Amount' }" format="{ type: 'currency', precision: 2 }"></dxi-item>
        <dxi-item dataField="bankCheckAmount" [label]="{ text: 'Check Amount' }"></dxi-item>
      </dx-form>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()">Save</button>
  <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
